import { useTranslation } from 'react-i18next';
import { FaCheck, FaStar } from 'react-icons/fa';

import styles from './FreeTrialTimeline.module.css';

interface Step {
    titleKey: string;
    descriptionKey: string;
    completed: boolean;
}

const steps: Step[] = [
    {
        titleKey: 'freeTrial.steps.test.title',
        descriptionKey: 'freeTrial.steps.test.description',
        completed: true,
    },
    {
        titleKey: 'freeTrial.steps.unlock.title',
        descriptionKey: 'freeTrial.steps.unlock.description',
        completed: false,
    },
    {
        titleKey: 'freeTrial.steps.reminder.title',
        descriptionKey: 'freeTrial.steps.reminder.description',
        completed: false,
    },
    {
        titleKey: 'freeTrial.steps.end.title',
        descriptionKey: 'freeTrial.steps.end.description',
        completed: false,
    },
];

export function FreeTrialTimeline() {
    const { t } = useTranslation();

    return (
        <div className={styles.timeline}>
            {steps.map((step, index) => (
                <div key={index} className={styles.step}>
                    <div className={styles.iconCol}>
                        <div className={`${styles.icon} ${step.completed ? styles.iconCompleted : styles.iconPending}`}>
                            {step.completed ? <FaCheck size={14} /> : <FaStar size={14} />}
                        </div>
                        {index < steps.length - 1 && <div className={styles.line} />}
                    </div>
                    <div className={styles.textCol}>
                        <p className={styles.stepTitle}>{t(step.titleKey)}</p>
                        <p className={styles.stepDescription}>{t(step.descriptionKey)}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}
